module.exports = __webpack_public_path__ + "img/personRegisterBook.bba3cda4.svg";